import { render, staticRenderFns } from "./DocumentationTab.vue?vue&type=template&id=0b11e846&scoped=true&"
var script = {}
import style0 from "./DocumentationTab.vue?vue&type=style&index=0&id=0b11e846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11e846",
  null
  
)

export default component.exports